// React Imports
import { ReactElement, useState } from "react";

// Third Party Libraries Imports
import { ReactSVG } from "react-svg";
import { Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { Link } from "react-router-dom";

// Local Imports
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import CustomTable from "../../components/custom-table/custom-table";
import CustomSearch from "../../components/custom-search/custom-search";
import CustomModal from "../../components/custom-modal/custom-modal";
import ViewNews from "./components/view-news/view-news";
import { NewsTableColumnType } from "./types";

const News: React.FC = (): ReactElement => {
  const [openViewModal, setOpenViewModal] = useState<boolean>(false);

  const columns: ColumnsType<NewsTableColumnType> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Topics",
      dataIndex: "topics",
      key: "topics",
      width: 140,
      sorter: (a, b) => a.topics.length - b.topics.length,
      fixed: "left",
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.length - b.title.length,
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
      width: 150,
      sorter: (a, b) => a.url.length - b.url.length,
      render: (text: string) => <Link to={text}>{text}</Link>,
    },

    {
      title: "Published",
      dataIndex: "published",
      key: "published",
      sorter: (a, b) => a.published.length - b.published.length,
    },
    {
      title: "Language",
      dataIndex: "language",
      key: "language",
      sorter: (a, b) => a.language.length - b.language.length,
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      width: 150,
      render: () => (
        <div className="flex items-center gap-2">
          <ReactSVG src={"/images/view.svg"} onClick={() => setOpenViewModal(true)} />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between flex-wrap">
        <BreadcrumbComponent />
      </div>
      <div>
        <div className=" flex items-center justify-between rounded-lg bg-white py-[10px] px-5">
          <p className=" text-black-300 text-base font-bold">2 News</p>
          <div className="flex items-center">
            <CustomSearch />
            <Tooltip placement="topLeft" title="Columns settings">
              <img src={"/images/grid.svg"} alt="grid" />
            </Tooltip>
          </div>
        </div>
        <CustomTable columns={columns} data={[]} />
      </div>

      <CustomModal
        isVisible={openViewModal}
        centered
        width={900}
        showClose={false}
        onClose={() => {
          setOpenViewModal(false);
        }}
        className="edit-modal"
      >
        <div className="flex flex-col items-center justify-center">
          <ViewNews
            onCancel={() => {
              setOpenViewModal(false);
            }}
          />
        </div>
      </CustomModal>
    </div>
  );
};

export default News;
